// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jxF10Ibjw3SAv_ncmCbq{width:100%;height:100%;display:flex;justify-content:center}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi{margin:auto;display:flex;flex-wrap:nowrap;flex-direction:column;align-content:center;justify-content:center;height:fit-content;width:80%}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl{display:flex;flex-direction:row;width:100%}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD .IY5gGJqtohCIFNRfaELB,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl .IY5gGJqtohCIFNRfaELB{border-right:1px solid #d0dae9;padding-right:4em}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD .ctXAE3Vuma4Q6tEPg7ib,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl .ctXAE3Vuma4Q6tEPg7ib{margin-left:4em}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD .IY5gGJqtohCIFNRfaELB,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD .ctXAE3Vuma4Q6tEPg7ib,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl .IY5gGJqtohCIFNRfaELB,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl .ctXAE3Vuma4Q6tEPg7ib{flex:1 1 50%;display:flex;flex-direction:column}.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .EtNFpxGXoYvAxYb_TKcD .mPfIh9p0eth4VhfWyD0r,.jxF10Ibjw3SAv_ncmCbq .GFegWY4aHncGQwmSossi .sqO0S3vH88cWpASJDwHl .mPfIh9p0eth4VhfWyD0r{border-top:1px solid #826ef5;width:100%;padding-top:1em;margin-top:1em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pageWrapper": `jxF10Ibjw3SAv_ncmCbq`,
	"tableWrapper": `GFegWY4aHncGQwmSossi`,
	"descriptionRow": `EtNFpxGXoYvAxYb_TKcD`,
	"audioRow": `sqO0S3vH88cWpASJDwHl`,
	"col1": `IY5gGJqtohCIFNRfaELB`,
	"col2": `ctXAE3Vuma4Q6tEPg7ib`,
	"buttonWrapper": `mPfIh9p0eth4VhfWyD0r`
};
export default ___CSS_LOADER_EXPORT___;
